export default __webpack_public_path__ + "static/media/Lora-Italic.9b8268a3.ttf";